export function getView(status) {
  if (status === 'processed') {
    return 'SyncPatients'
  }
  return 'Syncing'
}
